import React from "react";
import { useParams } from "react-router-dom";

export function Page(props){
  const { id } = useParams();
  return (
      <h1>페이지{id}</h1>
  );
};
